var React = require('react');

function ChevronCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a,.d{fill:none;}.a{stroke:#777b8c;}.b{fill:#777b8c;}.c{stroke:none;}")),React.createElement("g",{"transform":"translate(-0.146 451) rotate(-90)","key":1},[React.createElement("g",{"className":"a","transform":"translate(435 16.146) rotate(-90)","key":0},[React.createElement("circle",{"className":"c","cx":"8","cy":"8","r":"8","key":0}),React.createElement("circle",{"className":"d","cx":"8","cy":"8","r":"7.5","key":1})]),React.createElement("path",{"className":"b","d":"M3.27,0,6.54,5.295H0Z","transform":"translate(446.251 4.691) rotate(90)","key":1})])]);
}

ChevronCircle.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ChevronCircle;

ChevronCircle.default = ChevronCircle;
